import { TranslationKey } from 'state/intl/types';

const componentTheme = {
  buttonContrastColor: Styles.color.contrastBackground,
  points: 'crownPoints' as TranslationKey,
};

export default componentTheme;
